import { render } from "./TimeCalculation.vue?vue&type=template&id=c473841e"
import script from "./TimeCalculation.vue?vue&type=script&lang=js"
export * from "./TimeCalculation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__